import script from "./AdminArticleManageView.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminArticleManageView.vue?vue&type=script&setup=true&lang=js"

import "./AdminArticleManageView.vue?vue&type=style&index=0&id=12b9a13e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12b9a13e"]])

export default __exports__